<template>
  <v-form ref="modTextAreaForm" v-model="formValid" @submit.prevent v-if="existing">
    <v-list-item v-if="!editField">
      <v-list-item-content>
        <v-list-item-subtitle>{{ label }}</v-list-item-subtitle>
        {{ existing }}
      </v-list-item-content>
      <v-list-item-icon>
        <v-btn icon small @click="editField = true" title="Edit Field">
          <v-icon small color="warning" v-text="mdiPencilOutline" />
        </v-btn>
      </v-list-item-icon>
    </v-list-item>
    <v-list-item v-else>
      <v-list-item-content dense>
        <v-textarea
          v-model="newTextValue"
          :label="`Edit ${label}`"
          :rules="rules"
          filled
          counter
          maxlength="512"
          color="dw_green"
        ></v-textarea>
        <div class="d-flex pt-1">
          <v-btn
            type="button"
            @click="resetField"
            outlined
            x-small
            color="red">
            <v-icon x-small color="red" class="mr-1" v-text="mdiClose" />
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="button"
            :disabled="newTextValue === existing || !formValid"
            @click="updateField"
            outlined
            x-small
            color="dw_green">
            <v-icon x-small color="dw_green" class="mr-1" v-text="mdiContentSaveOutline" />
            Save
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-form>
</template>

<script>
import { mdiContentSaveOutline, mdiPencilOutline, mdiClose } from '@mdi/js';
import { mapActions } from 'vuex';
import utils from '@/utils/index';

export default {
  name: 'moderateTextArea',
  props: ['existing', 'label', 'isRequired'],
  data() {
    return {
      mdiContentSaveOutline,
      mdiPencilOutline,
      mdiClose,
      editField: false,
      formValid: false,
      newTextValue: ''
    }
  },
  watch: {
    editField() {
      if (this.editField) this.newTextValue = this.existing;
    }
  },
  computed: {
    rules() {
      let validRules = [
        utils.validationRules.min,
        utils.validationRules.descMax,
        utils.validationRules.textRegex
      ];
      if (this.isRequired) validRules = validRules.splice(0, 0, utils.validationRules.required);
      return validRules;
    }
  },
  methods: {
    updateField() {
      this.$emit('saveChanges', this.newTextValue);
      this.editField = false;
    },
    resetField() {
      this.editField = false;
    }
  }
};
</script>
